import { ColumnsType } from '@setvi/shared/types';
import { Customer } from 'Services/Mongo/Types';
import {
  ProductColumn,
  ProductDetailsColumnsIds,
  ProductInventory,
  StockInfo
} from '@setvi/shared/interfaces';
import {
  getWarehouseLocation,
  withStockedColumn
} from 'componentsV2/product/details/content/subpages/warehouse/useWarehouseColumns';
import { getWarehouseCellContent } from './content';

interface useWarehouseColumnsProps {
  selectedCustomer?: Customer;
  configColumns: ProductColumn[];
  stockInfo?: StockInfo;
}

export const useWarehouseColumns = ({
  selectedCustomer,
  configColumns = [],
  stockInfo
}: useWarehouseColumnsProps) => {
  const warehouseColumns: ColumnsType = withStockedColumn(
    configColumns,
    stockInfo
  ).map(column => ({
    ...column,
    cellContent: (row: ProductInventory) =>
      getWarehouseCellContent({
        label: column.label,
        id: column.id as ProductDetailsColumnsIds,
        row,
        selectedCustomer,
        stockInfo,
        getWarehouseLocation
      })
  }));

  return {
    warehouseColumns
  };
};
